export default {
  "UNKNOWN": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error. Please try again or contact the administrator."])},
  "APP_ERROR": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The application seems to have encountered some issues.<br />Please try again later or contact the administrator."])},
  "NOT_FOUND": {
    "PAGE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page not found"])},
    "WORKOUT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Workout not found"])}
  },
  "SOMETHING_WRONG": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Something went wrong"])}
}